import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { FormbricksService } from '@core/services/formbricks.service';

declare let fbq: Function;

@Component({
	selector: 'kwo-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	standalone: false
})
export class AppComponent implements OnInit {

	constructor(private titleService: Title,
		translate: TranslateService,
		private googleTagManagerService: GoogleTagManagerService,
		private formbricksService: FormbricksService,
		private router: Router) {

		translate.use('nl');
		translate.get('app.title').subscribe((title: string) => {

			titleService.setTitle(title);
		});

		this.router.events.forEach(item => {

			if (item instanceof NavigationEnd) {

				const tag = {
					event: 'page',
					pageName: item.url
				};

				console.log(tag);

				this.googleTagManagerService.pushTag(tag);
				fbq('track', 'PageView');
				this.formbricksService.registerRouteChange();
			}
		});
	}

	ngOnInit() {


	}
}
